import {
  kAcquireMore,
  kPushDecoder,
  kStartDecoder,
  kStartDownloader,
  kStopDecoder,
  kStopDownloader,
  kVideoFrame,
  kVideoPacket,
  kWsEvent,
  Logger
} from "./whCommon";
import {
  WebGLPlayer
} from "./whWebglPlayer";

// 万华WebGL播放器
export class WHPlayer {
  constructor(options, wsCallback) {
    const downloadWorkerSrc = options && options.downloadWorker ? options.downloadWorker : `${window.deployBaseRoute || '/'}public/vendors/iot/wh/downloader.js`
    const decoderWorkerSrc = options && options.decoderWorker ? options.decoderWorker : `${window.deployBaseRoute || '/'}public/vendors/iot/wh/decoder.js`

    this.url = null;
    this.startTs = 0;
    this.endTs = 0;
    this.curEndTs = 0;
    this.stepTs = 20; // seconds
    this.canvas = null;
    this.webglPlayer = null;
    this.renderDataArray = null;
    this.renderDataFirstTs = -1;
    this.renderDataFirstClock = -1;
    this.renderTimer = null;
    this.logger = new Logger("Player");
    this.beginFrames = [];
    this.decodeWorkerFlag = false;
    this.playCallback = null;
    this.downloadCallback = null;
    this.errorTimer = null;
    this.wsEventCallback = null;

    const self = this;
    this.downloadWorker = new Worker(downloadWorkerSrc);

    this.downloadWorker.onmessage = function (evt) {
      const objData = evt.data;
      wsCallback && wsCallback(evt)
      switch (objData.t) {
        case kWsEvent:
          if (self.wsEventCallback) {
            self.wsEventCallback(objData.v, objData.c, objData.r);
          }
          break;

        case kVideoPacket:
          if (self.renderDataArray) {
            if (self.decodeWorkerFlag == false) {
              while (self.beginFrames.length > 2) {
                self.beginFrames.shift();
              }
              self.beginFrames.push(objData.d);

              let isH265 = -1;
              let buffer0 = null;
              let buffer1 = null;
              let buffer2 = null;
              if (self.beginFrames.length >= 2) {
                buffer0 = new Uint8Array(self.beginFrames[0]);
                buffer1 = new Uint8Array(self.beginFrames[1]);
                if (self.beginFrames.length == 3) {
                  buffer2 = new Uint8Array(self.beginFrames[2]);
                }
              }

              if (
                self.beginFrames.length == 2 &&
                (buffer0[16] & 0x1f) == 7 &&
                (buffer1[16] & 0x1f) == 8
              ) {
                isH265 = 0;
                self.logger.logInfo(`isH265=${isH265}`);
              } else if (
                self.beginFrames.length == 3 &&
                (buffer1[16] & 0x1f) == 7 &&
                (buffer2[16] & 0x1f) == 8
              ) {
                isH265 = 0;
                self.beginFrames.shift();
                self.logger.logInfo(`isH265=${isH265}`);
              }

              if (
                isH265 == -1 &&
                buffer0 &&
                buffer1 &&
                buffer2 &&
                (buffer0[16] & 0x7e) >> 1 == 32 &&
                (buffer1[16] & 0x7e) >> 1 == 33 &&
                (buffer2[16] & 0x7e) >> 1 == 34
              ) {
                isH265 = 1;
                self.logger.logInfo(`isH265=${isH265}`);
              }

              if (isH265 != -1) {
                //self.startDecodeWorker(isH265, self.startTs > 0 && self.endTs > self.startTs);
                self.startDecodeWorker(isH265, true);
                self.decodeWorkerFlag = true;

                for (let j = 0; j < self.beginFrames.length; ++j) {
                  var postData = {
                    t: kPushDecoder,
                    d: self.beginFrames[j],
                  };
                  self.decodeWorker.postMessage(postData, [postData.d]);
                }
              }
            } else {
              var postData = {
                t: kPushDecoder,
                d: objData.d,
              };
              self.decodeWorker.postMessage(postData, [postData.d]);
            }
          }
          break;

        default:
          break;
      }
    }

    this.decodeWorker = new Worker(decoderWorkerSrc);
    this.decodeWorker.onmessage = function (evt) {
      const objData = evt.data;
      switch (objData.t) {
        case kVideoFrame:
          if (self.renderDataArray) {
            if (self.renderDataArray.length >= 30) {
              self.renderDataArray.shift();
            }
            self.renderDataArray.push(objData);

            if (self.startTs > 0 && self.endTs > self.startTs) {
              const deltaTs =
                self.curEndTs - self.startTs - objData.p / 1000;
              if (
                self.curEndTs != self.endTs &&
                deltaTs < self.stepTs / 2
              ) {
                const oldEndTs = self.curEndTs;
                self.curEndTs += self.stepTs;
                if (self.curEndTs > self.endTs) {
                  self.curEndTs = self.endTs;
                }
                self.downloadWorker.postMessage({
                  t: kAcquireMore,
                  s: oldEndTs,
                  e: self.curEndTs,
                });
              }
            }
          }
          break;
        default:
          break;
      }
    };
  }

  renderFrame(self) {
    let objData = null;
    while (self.renderDataArray.length > 0) {
      objData = self.renderDataArray.shift();
      const nowTime = new Date().getTime();
      if (self.renderDataFirstTs === -1) {
        self.renderDataFirstTs = objData.p;
        self.renderDataFirstClock = nowTime;
      } else if (
        nowTime - self.renderDataFirstClock <
        objData.p - self.renderDataFirstTs
      ) {
        self.renderDataArray.unshift(objData);
        break;
      }
      // console.log("render " + (objData.p - self.renderDataFirstTs) + " " + (nowTime - self.renderDataFirstClock));
      self.webglPlayer.renderFrameYUV(
        objData.y,
        objData.u,
        objData.v,
        objData.w,
        objData.h
      );
      if (self.playCallback) {
        self.playCallback(objData.p);
      }
    }
  }

  startDownloadWorker() {
    const sym = this.url.indexOf("?") > 0 ? "&" : "?";
    let reqUrl = `${this.url}`;
    // let reqUrl = `${this.url}${sym}responseType=1`;
    if (this.startTs > 0 && this.endTs > this.startTs) {
      this.curEndTs = this.startTs + this.stepTs;
      if (this.curEndTs > this.endTs) {
        this.curEndTs = this.endTs;
      }
      reqUrl = `${reqUrl}&startTs=${this.startTs}&endTs=${this.curEndTs}`;
    }
    const req = {
      t: kStartDownloader,
      u: reqUrl,
    };
    this.downloadWorker.postMessage(req);
  }

  startDecodeWorker(isH265, isPlayback) {
    const req = {
      t: kStartDecoder,
      v: isH265,
      s: isPlayback,
    };
    this.decodeWorker.postMessage(req);
  }

  fullscreen() {
    if (this.webglPlayer) {
      this.webglPlayer.fullscreen();
    }
  }

  exitfullscreen() {
    if (this.webglPlayer) {
      this.webglPlayer.exitfullscreen();
    }
  }

  stopRender() {
    if (this.webglPlayer) {
      this.webglPlayer.stopRender();
    }
  }

  startRender() {
    if (this.webglPlayer) {
      this.webglPlayer.startRender();
    }
  }

  start(url, canvas, playCallback, downloadCallback, wsEventCallback, startTs, endTs) {
    this.logger.logInfo(`Play ${url}.`);
    this.url = url;
    this.canvas = canvas;
    this.startTs = startTs != null ? startTs : 0;
    this.endTs = endTs != null ? endTs : 0;
    this.renderDataArray = [];
    this.downloadCallback = downloadCallback;
    this.playCallback = playCallback;
    this.wsEventCallback = wsEventCallback;
    // var playCanvasContext = playCanvas.getContext("2d"); //If get 2d, webgl will be disabled.
    this.webglPlayer = new WebGLPlayer(this.canvas, {
      preserveDrawingBuffer: true,
    });
    if (this.renderTimer) {
      clearInterval(this.renderTimer);
    }
    this.renderTimer = setInterval(this.renderFrame, 20, this);

    this.startDownloadWorker();
    return 0;

  }
  clear() {
    this.webglPlayer && this.webglPlayer.clearFrame();
  }
  stop() {
    this.downloadWorker.postMessage({
      t: kStopDownloader,
    });

    this.decodeWorker.postMessage({
      t: kStopDecoder,
    });

    this.decodeWorkerFlag = false;

    if (this.renderTimer) {
      clearInterval(this.renderTimer);
      this.renderTimer = null;
    }

    this.url = null;
    this.startTs = 0;
    this.endTs = 0;
    this.curEndTs = 0;
    this.canvas = null;
    this.webglPlayer = null;
    this.renderDataArray = null;
    this.beginFrames.length = 0;
    this.decodeWorkerFlag = false;
    this.playCallback = null;
    this.renderDataFirstTs = -1;
    this.renderDataFirstClock = -1;
    // 销毁worker
    setTimeout(() => {
      this.downloadWorker.terminate();
      this.decodeWorker.terminate();
      this.downloadWorker = null;
      this.decodeWorker = null;
    })
    return 0;
  }
}